<app-back-panel>


    <div class="mat-mdc-dialog-title">
        <h2 class="one">{{ 'activity_search.panel_title' | translate }}</h2>

        <ng-container *ngIf="selectedActivityIdList.length > 0">

            <div class="app-activity-search-engine-panel__selected-count-label">
                <mat-icon svgIcon="app-activity-search-engine-panel__selected-count-label__icon"></mat-icon>
                <span>{{ selectedActivityIdList.length }} {{ 'activity_search.selected_count_label' | translate }}</span>
            </div>

            <button (click)="onDeleteSelectionClick($event)"
                    class="app-activity-search-engine-panel__clear-selection-button">
                <span>{{ 'activity_search.clear_selection_button' | translate }}</span>
            </button>
            <button (click)="onImportSelectionClick($event)"
                    class="app-activity-search-engine-panel__validate-selection-button">
                <mat-icon class="app-activity-search-engine-panel__validate-selection-button__icon"
                          svgIcon="app-activity-search-engine-panel__validate-selection-button__icon"></mat-icon>
                {{ 'activity_search.validate_selection_button' | translate }}
            </button>
        </ng-container>


        <button aria-label="Close dialog"
                class="close"
                matDialogClose>
            <mat-icon svgIcon="cross"></mat-icon>
        </button>
    </div>

    <div [ngClass]="{'filter-is-selected':filters().length > 0}" class="mat-mdc-dialog-content">

        @if (filters().length > 0) {
            <app-filter-bar>
                <mat-chip-set>
                    @for (filter of filters(); track filter.label; let last = $last) {
                        <app-filter-chip class="mat-chip-list">
                            <span data-label>{{ filter.label }}</span>
                            @if (selectedActivityIdList.length === 0 && last) {
                                <button (click)="filter.onClick($event)"
                                        class="mat-chip-remove mat-chip-trailing-icon" data-action>
                                    <mat-icon svgIcon="cancel"></mat-icon>
                                </button>
                            }
                        </app-filter-chip>
                    }
                    <button (click)="goBackToFilters()" class="activity-search-engine-panel__button-resume_filters"
                            *ngIf="canAddMoreFilters()">
                        <span>{{ 'activity_search.resume_filters' | translate }}</span>
                    </button>
                    <button (click)="clearFilters()" class="activity-search-engine-panel__button-clear_filters"
                            *ngIf="selectedActivityIdList.length === 0">
                        <mat-icon svgIcon="trash"></mat-icon>
                        <span>{{ 'activity_search.clear_filters' | translate }}</span>
                    </button>
                </mat-chip-set>
            </app-filter-bar>
        }
        <div [ngClass]="{'lessons-search-viewer':state === 'lessons'}" class="content">

            <ng-container *ngIf="state === 'concepts'">
                <mat-icon class="app-activity-search-engine-panel__icon"
                          svgIcon="app-activity-search-engine-panel__icon"></mat-icon>
                <h2 class="three">{{ 'activity_search.' + state + '_filters' | translate }}</h2>
                <app-concept-filter-selector
                    (conceptSelected)="onConceptFilterSelected($event)"></app-concept-filter-selector>
                <button (click)="onPassButtonClick($event)"
                        class="app-activity-search-engine-panel__button">{{ 'activity_search.pass_action_label' | translate }}
                </button>
            </ng-container>

            <ng-container *ngIf="state === 'educational_levels_from_exclusive_list'">
                <h2 class="two2">{{ 'activity_search.educational_levels_filters' | translate }}</h2>
                <app-educational-level-filter-selector-of-concepts-list
                    (educationalLevelSelected)="onEducationalFilterSelected($event)"
                    [conceptList]="selectedConcepts"></app-educational-level-filter-selector-of-concepts-list>
                <button (click)="onPassButtonClick($event)"
                        class="app-activity-search-engine-panel__button">{{ 'activity_search.pass_action_label' | translate }}
                </button>
            </ng-container>

            <ng-container *ngIf="state === 'educational_levels'">
                <h2 class="two2">{{ 'activity_search.educational_levels_filters' | translate }}</h2>
                <mat-progress-spinner *ngIf="isEducationalLevelsLoading" mode="indeterminate"
                                      diameter="32"></mat-progress-spinner>
                <app-generic-filter-selector *ngIf="!isEducationalLevelsLoading"
                                             [availableFilters]="availableEducationalLevelsToFilters"
                                             [extraContextInfoForAccessibility]="'accessibility.educationnal_level_filter' | translate"
                                             (filterClick)="onEducationalFilterSelected($event.originalResource)">
                </app-generic-filter-selector>
                <button (click)="onPassButtonClick($event)"
                        class="app-activity-search-engine-panel__button">{{ 'activity_search.pass_action_label' | translate }}
                </button>
            </ng-container>

            <ng-container *ngIf="state === 'chapters'">
                <h2 class="two">{{ 'activity_search.' + state + '_filters' | translate }}</h2>
                <app-chapter-filter-selector (chapterSelected)="onChapterSelected($event)" [options]="{
            concepts: this.selectedConcepts,
            educationalLevels: this.selectedEducationalLevels,
        }"
                ></app-chapter-filter-selector>
                <button (click)="onPassButtonClick($event)"
                        class="app-activity-search-engine-panel__button">{{ 'activity_search.pass_action_label' | translate }}
                </button>
            </ng-container>

            <app-lessons-search-viewer *ngIf="state === 'lessons'" [lessonsSearchOptions]="lessonSearchOptions">

                <ng-template let-lesson="lesson" let-lessonIndex="index" let-parent="parent">
                    <app-lesson-horizontal-viewer [lessonIndex]="lessonIndex" [lesson]="lesson" [parentLesson]="parent">

                        <ng-template #header>
                            <ng-container *ngIf="!!parent">
                                {{ parent.attributes?.metadatas?.title }} -
                            </ng-container>
                            {{ lesson.attributes?.metadatas?.title }}
                            <button (click)="onAllActivitySelectionClick(lesson, lessonIndex)"
                                    *ngIf="!areAllActivitiesSelected(lesson, lessonIndex)">{{ 'generic.select_all' | translate }}
                            </button>
                            <button (click)="onDeselectAllActivitiesClick(lesson, lessonIndex)"
                                    *ngIf="areAllActivitiesSelected(lesson, lessonIndex)">{{ 'generic.deselect_all' | translate }}
                            </button>
                        </ng-template>

                        <ng-template #activity let-activity="activity" let-index="index">
                            <app-pretty-activity-card [ngClass]="{'active': isActivitySelected(index)}"
                                                      [activity]="activity">
                                <ng-container data-actions>
                                    <button [class.pretty-card__select-button]="!isActivitySelected(index)"
                                            [class.pretty-card__cancel-button]="isActivitySelected(index)"
                                            (click)="onActivityToggleSelectionClick(activity.id, index)">
                                        <mat-icon *ngIf="!isActivitySelected(index)" svgIcon="check"></mat-icon>
                                        <span>{{ (isActivitySelected(index) ? 'generic.cancel' : 'generic.select') | translate }}</span>
                                    </button>
                                </ng-container>
                            </app-pretty-activity-card>
                        </ng-template>

                    </app-lesson-horizontal-viewer>
                </ng-template>

            </app-lessons-search-viewer>
        </div>


    </div>

</app-back-panel>
